"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useViewport = void 0;
const react_1 = require("react");
function useViewport() {
    const [innerWidth, setInnerWidth] = react_1.useState(0);
    const [outerWidth, setOuterWidth] = react_1.useState(0);
    const [innerHeight, setInnerHeight] = react_1.useState(0);
    const [outerHeight, setOuterHeight] = react_1.useState(0);
    const isClient = () => {
        return typeof window === "object";
    };
    react_1.useEffect(() => {
        const getSize = () => ({
            innerWidth: isClient() ? window.innerWidth : 0,
            outerWidth: isClient() ? window.outerWidth : 0,
            innerHeight: isClient() ? window.innerHeight : 0,
            outerHeight: isClient() ? window.outerHeight : 0
        });
        const handleResize = () => {
            const size = getSize();
            setInnerWidth(size.innerWidth);
            setOuterWidth(size.outerWidth);
            setInnerHeight(size.innerHeight);
            setOuterHeight(size.outerHeight);
        };
        handleResize();
        window.addEventListener("resize", handleResize);
        return () => {
            window.removeEventListener("resize", handleResize);
        };
    }, []);
    return { innerWidth, outerWidth, innerHeight, outerHeight };
}
exports.useViewport = useViewport;
//# sourceMappingURL=useViewport.js.map